
import React, { useState } from 'react';
import {
  InputGrid,
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
  NotificationList,
  Button,
  MixedGridGroup,
  QuantaForm
} from 'quanta-ui';
import {
  PINCODE_LOOKUP,
  GET_TOWEDBY_GCV
} from '../../queries';
import {
  faPlus,
  faTrashAlt,
  // FontAwesomeIcon
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@apollo/client';
import { Loading } from 'quanta-flows/modules/layout';
//import useFetchQuery from './lib/graphql/useFetchCacheQuery';
import { useFetchQuery } from 'quanta-flows';
//import Parse from '../../../../../../lib/intl/CurrencyFormater';
// Parse is changed to CurrencyFormater
import { CurrencyFormater } from 'quanta-flows';

export default function Trailers({
  branding,
  lobCode,
  lobName,
  productCode,
  productName,
  quoteNumber,
  renderExpandedCards,
  isTrailerRequired,
  nooftrailers,
  modify
}) {
  const fetchQuery = useFetchQuery();
  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find(
      (d) =>
        d[`${searchType}`]?.toString()?.trim()?.toLowerCase() ===
        searchText?.toString()?.trim()?.toLowerCase(),
    )
      ? domainArr.find(
        (d) =>
          d[`${searchType}`]?.toString()?.trim()?.toLowerCase() ===
          searchText?.toString()?.trim()?.toLowerCase(),
      )[`${returnType}`]
      : '';
  };
  const { values, setFieldValue } = useQuantaFormikContext();
  const [expandCard, setExpandCard] = useState(
    renderExpandedCards?.current
      ?.filter((card) =>
        card?.cardName
          ?.toString()
          ?.toLowerCase()
          ?.startsWith('trailer'),
      )
      ?.sort((a, b) => {
        if (
          a?.cardName?.toString()?.toLowerCase() <
          b?.cardName?.toString()?.toLowerCase()
        ) {
          return -1;
        } else if (
          a?.cardName?.toString()?.toLowerCase() >
          b?.cardName?.toString()?.toLowerCase()
        ) {
          return 1;
        }
        return 0;
      })
      ?.findIndex(
        (card) =>
          card?.cardName
            ?.toString()
            ?.toLowerCase()
            ?.startsWith('trailer') && card?.flag,
      ),
  );
  
  const [alerts, setAlerts] = useState([]);
  const [loadingPermCustAddr, setLoadingPermCustAddr] =
    useState(false);
  // console.log("values",values)
  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  let inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });
  let repeatForMobile = 1;
  let repeatForDesktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  let gridData =  values.trailerDetails?.flatMap((_, idx) => {
   return [ 
     {
        title: `Trailer ${idx + 1}`,
        expanded: expandCard === idx ? true : false,
        // expanded: renderExpandedCards?.current?.find(
        //   (card) =>
        //     card?.cardName?.toString()?.toLowerCase() ===
        //     `trailer ${idx + 1}`,
        // )?.flag,
        isToggleEnabled: true,
        controlExpanded: expandCard === idx ? true : false,
        // controlExpanded: renderExpandedCards?.current?.find(
        //   (card) =>
        //     card?.cardName?.toString()?.toLowerCase() ===
        //     `trailer ${idx + 1}`,
        // )?.flag,
        setExpandedCards: (expanded) => {
          if (expanded) {
            setExpandCard(idx);
            renderExpandedCards.current = [
              ...renderExpandedCards?.current
                ?.filter(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() !==
                      `trailer ${idx + 1}` &&
                    card?.cardName
                      ?.toString()
                      ?.toLowerCase()
                      ?.startsWith('trailer'),
                )
                ?.map((card) => {
                  return {
                    ...card,
                    flag: false,
                  };
                }),
              ...renderExpandedCards?.current?.filter(
                (card) =>
                  !card?.cardName
                    ?.toString()
                    ?.toLowerCase()
                    ?.startsWith('trailer'),
              ),
              {
                ...renderExpandedCards?.current?.find(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() ===
                    `trailer ${idx + 1}`,
                ),
                flag: expanded,
              },
            ];
          } else {
            renderExpandedCards.current = [
              ...renderExpandedCards?.current?.filter(
                (card) =>
                  card?.cardName?.toString()?.toLowerCase() !==
                  `trailer ${idx + 1}`,
              ),
              {
                ...renderExpandedCards?.current?.find(
                  (card) =>
                    card?.cardName?.toString()?.toLowerCase() ===
                    `trailer ${idx + 1}`,
                ),
                flag: expanded,
              },
            ];
          }
        },
        grid_data : [
          {
            title: 'Trailer details',
            type: 'text',
            size: 'large',
            label: (
              <>Make<Text severity="error"></Text>
              </>
            ),
            name: `trailerDetails[${idx}].make`,
            disabled: (values?.quotationNo !== '' && !modify ),
            className: `${(values?.quotationNo !== '' && !modify ) ? 'border-neutral-dark' : ''
              }`,
            iconPre: (
              <Text
                severity={
                  (values?.quotationNo !== '' && !modify ) ? 'neutral-darker' : 'info'
                }
              >
              </Text>
            ),
              },

          {
            type: 'text',
            size: 'large',
            label: (
              <>Model<Text severity="error"></Text>
              </>
            ),
            name: `trailerDetails[${idx}].model`,
            disabled: (values?.quotationNo !== '' && !modify ),
            className: `${(values?.quotationNo !== '' && !modify ) ? 'border-neutral-dark' : ''
              }`,
            iconPre: (
              <Text
                severity={
                  (values?.quotationNo !== '' && !modify ) ? 'neutral-darker' : 'info'
                }
              >
              </Text>
            ),
          },
      
          {
            type: 'text',
            size: 'large',
            label: (
              <>Registration Number<Text severity="error">*</Text>
              </>
            ),
            name: `trailerDetails[${idx}].regnumber`,
            disabled: (values?.quotationNo !== '' && !modify ),
            className: `${(values?.quotationNo !== '' && !modify ) ? 'border-neutral-dark' : ''
              }`,
            iconPre: (
              <Text 
                severity={
                  (values?.quotationNo !== '' && !modify ) ? 'neutral-darker' : 'info'
                }
              >
              </Text>
            ),
          } ,
        
          {
            type: 'text',
            size: 'large',
            label: (
              <>Chassis Number<Text severity="error">*</Text>
              </>
            ),
            name: `trailerDetails[${idx}].ChassisNumber`,
            disabled: (values?.quotationNo !== '' && !modify ),
            className: `${(values?.quotationNo !== '' && !modify ) ? 'border-neutral-dark' : ''
              }`,
            iconPre: (
              <Text 
                severity={
                  (values?.quotationNo !== '' && !modify ) ? 'neutral-darker' : 'info'
                }
              >
              </Text>
            ),
          } ,
      
          {
            type: 'number',
            size: 'large',
            label: (
              <>SI(In Rupees)<Text severity="error">*</Text>
              </>
            ),
            name: `trailerDetails[${idx}].SI`,
            disabled: (values?.quotationNo !== '' && !modify ),
            className: `${(values?.quotationNo !== '' && !modify ) ? 'border-neutral-dark' : ''
              }`,
            iconPre: (
              <Text
                severity={
                  (values?.quotationNo !== '' && !modify ) ? 'neutral-darker' : 'info'
                }
              >
                {branding.currency}
              </Text>
            ),
          },
      
          {
            type: 'text',
            size: 'large',
            label: (
              <>Year Of Manufacture<Text severity="error">*</Text>
              </>
            ),
            name: `trailerDetails[${idx}].yearofmanufacture`,
            disabled: (values?.quotationNo !== '' && !modify ),
            maxlength: 4 ,
            className: `${(values?.quotationNo !== '' && !modify ) ? 'border-neutral-dark' : ''
              }`,
            iconPre: (
              <Text 
                severity={
                  (values?.quotationNo !== '' && !modify ) ? 'neutral-darker' : 'info'
                }
              >
              </Text>
            ),
          } ,
          {
            type: 'render',
            component: () =>
              values.trailerDetails.length > 1 && (
                <div className="flex justify-end mt-7">
                  <Button
                    type="button"
                    className="w-24 h-10"
                    size="small"
                    onClick={(_) => {
                      if (expandCard === values?.trailerDetails?.length - 1) {
                        setExpandCard(values?.trailerDetails?.length - 2);
                      }
                      renderExpandedCards.current = [
                        ...renderExpandedCards?.current?.filter(
                          (card) =>
                            (card?.cardName
                              ?.toString()
                              ?.toLowerCase()
                              ?.startsWith('trailer') &&
                              parseInt(
                                card?.cardName
                                  ?.toString()
                                  ?.split(' ')[1],
                              ) <
                                idx + 1) ||
                            !card?.cardName
                              ?.toString()
                              ?.toLowerCase()
                              ?.startsWith('trailer'),
                        ),
                        ...renderExpandedCards?.current
                          ?.filter(
                            (card) =>
                              card?.cardName
                                ?.toString()
                                ?.toLowerCase()
                                ?.startsWith('trailer') &&
                              parseInt(
                                card?.cardName
                                  ?.toString()
                                  ?.split(' ')[1],
                              ) >
                                idx + 1,
                          )
                          ?.map((card) => {
                            return {
                              cardName: `trailer ${
                                parseInt(
                                  card?.cardName
                                    ?.toString()
                                    ?.split(' ')[1],
                                ) - 1
                              }`,
                              flag: renderExpandedCards?.current?.find(
                                (c) =>
                                  c?.cardName
                                    ?.toString()
                                    ?.toLowerCase()
                                    ?.startsWith('trailer') &&
                                  parseInt(
                                    c?.cardName
                                      ?.toString()
                                      ?.toLowerCase()
                                      ?.split(' ')[1],
                                  ) ===
                                    parseInt(
                                      card?.cardName
                                        ?.toString()
                                        ?.toLowerCase()
                                        ?.split(' ')[1] - 1,
                                    ),
                              )?.flag,
                            };
                          }),
                      ];
                      setFieldValue(`trailerDetails`, [
                        ...values.trailerDetails.slice(0, idx),
                        ...values.trailerDetails.slice(idx + 1),
                      ]);
                    }}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} />
                    <span className="ml-2">Delete</span>
                  </Button>
                </div>
              ),
          },
        ].filter((d) => d),
      }
  ];//.filter((d) => d);

});
const other_props = {
  flow: 'cols',
  textType: 'normal',
  repeat,
  gapX: 2,
  gapY: 0,
  spaceY: 2,
  size: 'full',
  titleSeverity: 'info',
  useExpandablePaper: true,
};
  return (
    <>
      <QuantaForm>
        <MixedGridGroup {...{ data: gridData, ...other_props }} />
        { (isTrailerRequired)&&(values?.trailerDetails?.length<nooftrailers)&&
        <div className="flex justify-end mt-3">
          <Button
            type="button"
            className="h-10"
            size="small"
            iconPre={
              <FontAwesomeIcon icon={faPlus} className="mr-2" />
            }
            onClick={(_) => {
              setExpandCard(values?.trailerDetails?.length);
              renderExpandedCards.current = [
                ...renderExpandedCards?.current
                  ?.filter((card) =>
                    card?.cardName
                      ?.toString()
                      ?.toLowerCase()
                      ?.startsWith('trailer'),
                  )
                  ?.map((card) => {
                    return {
                      ...card,
                      flag: false,
                    };
                  }),
                ...renderExpandedCards?.current?.filter(
                  (card) =>
                    !card?.cardName
                      ?.toString()
                      ?.toLowerCase()
                      ?.startsWith('trailer'),
                ),
              ];
              renderExpandedCards?.current?.push({
                cardName: `trailer ${values?.trailerDetails?.length + 1}`,
                flag: true,
              });
              setFieldValue(`trailerDetails`, [
                ...values.trailerDetails,
                {
                  make: '',
                  model: '',
                  regnumber: '',
                  ChassisNumber: '',
                  SI:"",
                  yearofmanufacture: '',
                },
              ]);
            }}
          >
            <span className="text-sm">Add Trailer</span>
          </Button>
        </div>
        }
      </QuantaForm>
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
    </>
  );
}
